Application.Postcard.Recipient = {
    ui: {
        container: '.js-postcard-recipient',
        inputs: {
            firstName: '.js-postcard-recipient__first-name',
            lastName: '.js-postcard-recipient__last-name',
            company: '.js-postcard-recipient__company',
            street: '.js-postcard-recipient__street',
            city: '.js-postcard-recipient__city',
            country: '.js-postcard-recipient__country',
            zip: '.js-postcard-recipient__zip',
        }
    },
    postcard: null,
    ready: function (postcard) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.postcard = postcard;

        // bind handlers
        this.bind();

        // update on load
        this.update();

    },
    bind: function(){

        var self = this;

        // update postcard on textarea change
        $(document).on('keyup change', _.values(this.ui.inputs).join(', '), this.update.bind(this));

    },
    update: function(){

        // name, collate names and company
        var name = $(this.ui.inputs.firstName).val() + ' ' + $(this.ui.inputs.lastName).val();
        var company = $(this.ui.inputs.company).val();
        if (name && company){
            this.postcard.setName(name, company);
        }else{
            this.postcard.setName(name ? name : company);
        }

        this.postcard.setStreet($(this.ui.inputs.street).val());
        this.postcard.setCity($(this.ui.inputs.city).val());
        this.postcard.setCountry($(this.ui.inputs.country).find('option:selected:not([value="placeholder"])').text());
        this.postcard.setZip($(this.ui.inputs.zip).val());

    }
};